<!-- Один комментарий в обсуждении пометки по ТС. -->
<template>
  <div class="vehicle-remark-comment-item">
    <UserIdentityCard
      :user="comment.created_by"
      :name="authorLabel(comment.created_by)"
      fallback-name="Пользователь"
      fallback-initials="П"
      avatar-only
      class="vehicle-remark-comment-item__avatar"
    />

    <div class="vehicle-remark-comment-item__content">
      <div class="vehicle-remark-comment-item__meta">
        <span>{{ authorLabel(comment.created_by) }}</span>
        <span v-if="comment.created_at">
          {{ formatDateAndTime(comment.created_at) }}
        </span>

        <button
          v-if="canDestroy"
          type="button"
          class="vehicle-remark-comment-item__destroy"
          :disabled="isSubmitting"
          @click="showDestroyConfirm = true"
        >
          <AppIcon
            name="trash"
            :size="10"
            class="vehicle-remark-comment-item__destroy-icon"
          />
          Удалить
        </button>
      </div>

      <p class="vehicle-remark-comment-item__text">
        {{ comment.text }}
      </p>

      <AttachmentViewer
        v-if="hasAttachments"
        :attachments="comment.attachments"
      />
    </div>
  </div>

  <BaseDialog
    :visible="showDestroyConfirm"
    title="Удалить комментарий?"
    message="Комментарий будет удалён безвозвратно."
    :actions="destroyDialogActions"
    @action="handleDestroyDialogAction"
  />
</template>

<script>
import AttachmentViewer from "@/components/Attachment/Viewer.vue";
import AppIcon from "@/components/Icon/AppIcon.vue";
import UserIdentityCard from "@/components/User/UserIdentityCard.vue";

import { formatDateAndTime } from "@/utils/dateUtils";

export default {
  name: "VehicleRemarkCommentsItem",

  components: {
    AppIcon,
    AttachmentViewer,
    UserIdentityCard,
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
    currentUserId: {
      type: [String, Number],
      default: null,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["destroy"],

  data() {
    return {
      showDestroyConfirm: false,
    };
  },

  computed: {
    hasAttachments() {
      return Boolean(this.comment.attachments?.length);
    },

    canDestroy() {
      return String(this.comment.created_by_id) === String(this.currentUserId);
    },

    destroyDialogActions() {
      return [
        {
          key: "confirm",
          label: "Удалить",
          type: "danger",
          disabled: this.isSubmitting,
        },
        {
          key: "close",
          label: "Отмена",
          type: "secondary",
        },
      ];
    },
  },

  methods: {
    authorLabel(user) {
      return user?.initials || "Пользователь";
    },

    handleDestroyDialogAction(actionKey) {
      this.showDestroyConfirm = false;
      if (actionKey !== "confirm") return;

      this.$emit("destroy", this.comment);
    },

    formatDateAndTime,
  },
};
</script>

<style scoped>
.vehicle-remark-comment-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.vehicle-remark-comment-item__avatar {
  /* Длинный комментарий не должен сжимать обёртку аватара. */
  flex-shrink: 0;
  margin-top: 1px;
}

.vehicle-remark-comment-item__content {
  flex: 1;
  min-width: 0;
}

.vehicle-remark-comment-item__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
}

.vehicle-remark-comment-item__destroy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
  color: #64748b;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  cursor: pointer;
}

.vehicle-remark-comment-item__destroy-icon {
  transform: translateY(-1px);
}

.vehicle-remark-comment-item__destroy:hover:not(:disabled) {
  color: var(--color-danger);
}

.vehicle-remark-comment-item__destroy:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vehicle-remark-comment-item__text {
  margin: 4px 0 0;
  color: #111827;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.vehicle-remark-comment-item :deep(.attachments-viewer) {
  margin-top: 8px;
}

.vehicle-remark-comment-item :deep(.attachments-container) {
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}

.vehicle-remark-comment-item :deep(.attachment-preview-container) {
  height: 72px;
}
</style>
